import { AuthService } from 'apps/ubivu-panel/src/app/serveices/auth.service';
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationsService } from 'apps/ubivu-panel/src/app/serveices/configurations.service';
import { NodeService } from 'apps/ubivu-panel/src/app/serveices/node.service';


@Injectable({
    providedIn: 'root'
  })
export class WifiHelper {
    $unsubscribe: Subject<void> = new Subject();
    columnName: string; // For sorting
    sortingOrder: string;
    constructor(public authService: AuthService, public _configurationsService: ConfigurationsService,
                public _nodeService: NodeService) {
    }

    getVenueLists(){
        const params = {
            sort_by: this.columnName ? this.columnName : 'name',
            sort_dir: this.sortingOrder ? this.sortingOrder : 'asc',
        };
        return this._configurationsService.getVenueList(params).pipe(
            takeUntil(this.$unsubscribe),
            finalize(() => {
        }));
    }

}

